import { ButtonWithIcon } from "@src/components/atoms/buttons/button-with-icon/button-with-icon";
import { Title } from "@src/components/atoms/title/title";
import React from "react";
import styles from "./ota-configuration-start.module.scss";
import ConfigurationIcon from "@src/assets/svg/configurations-black-icon.svg";
import { useDispatch } from "react-redux";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasPermission } from "@src/components/molecules/render-if-user-has-permission/render-if-user-has-permission";

const cssClassName = "ota-configuration-start";

const OtaConfigurationsStart = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();
  const texts = {
    noConfigurationAvailableText: i18n(
      "modules.otaConfigurationStart.noConfigurationAvailableText",
    ),
    uploadYourConfigurationText: i18n(
      "modules.otaConfigurationStart.uploadYourConfigurationText",
    ),
    uploadConfigurationText: i18n(
      "modules.otaConfigurationStart.uploadConfigurationText",
    ),
  };
  const showOTAConfigurationDrawer = () => {
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "otaConfigurationDrawerModal",
      }),
    );
  };
  return (
    <div className={styles[cssClassName]}>
      <p className={styles[`${cssClassName}__no-configuration`]}>
        {texts.noConfigurationAvailableText}
      </p>
      <RenderIfUserHasPermission permission="manage-configuration">
        <Title text={texts.uploadYourConfigurationText} tag={"h2"} />
        <div className={styles[`${cssClassName}__cta`]}>
          <ButtonWithIcon
            fun={() => showOTAConfigurationDrawer()}
            text={texts.uploadConfigurationText}
            icon={ConfigurationIcon}
          />
        </div>
      </RenderIfUserHasPermission>
    </div>
  );
};

export default OtaConfigurationsStart;
